import LinearProgress, { linearProgressClasses, LinearProgressProps } from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { styled } from '@mui/material';

interface LinearProgressWithLabelProps extends LinearProgressProps {
    value: number;
    barColor?: string;
    showPercentage?: boolean;
}

const BorderLinearProgress = styled(LinearProgress, {
    shouldForwardProp: (prop) => prop !== "barColor",
})<{ barColor?: string }>(({ barColor }) => ({
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: `${barColor}40`,
        // backgroundColor: '#dda31040'
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,
        backgroundColor: barColor || '#FFB800',
    },
}));

export const LinearProgressWithLabel = (props: LinearProgressWithLabelProps) => {
    const { value, barColor, showPercentage, ...rest } = props;
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', mt:1.25}}>
            <Box sx={{ width: '100%', mr: 1 }}>
                <BorderLinearProgress variant="determinate" value={value} barColor={barColor} {...rest} />
            </Box>
            {showPercentage && <Box sx={{ minWidth:35 }}>
                <Typography
                    variant="body2"
                    sx={{ color: 'text.secondary' }}
                >{`${Math.round(value)}%`}</Typography>
            </Box>}
        </Box>
    );
};
